import type { NevmData } from '../api/types';

const NEVM_EXPLORER_URL =
  import.meta.env.VITE_NEVM_EXPLORER_URL || 'https://explorer.syscoin.org';

interface NevmSummaryCardProps {
  nevm: NevmData;
}

export const NevmSummaryCard = ({ nevm }: NevmSummaryCardProps) => (
  <div>
    <h2 style={{ marginTop: '30px' }}>NEVM Layer Data</h2>
    <div className="navigation-card" style={{ borderColor: '#4CAF50' }}>
      <p style={{ marginBottom: '15px' }}>
        This UTXO block contains NEVM (EVM-compatible) layer data committed in
        the coinbase transaction:
      </p>

      <div className="info-grid">
        <div className="info-item">
          <strong>NEVM Block Hash:</strong>
          <code className="hash-display">{nevm.block_hash}</code>
        </div>
        <div className="info-item">
          <strong>Transaction Root:</strong>
          <code className="hash-display">{nevm.tx_root}</code>
        </div>
        <div className="info-item">
          <strong>Receipt Root:</strong>
          <code className="hash-display">{nevm.receipt_root}</code>
        </div>
      </div>

      <p style={{ marginTop: '15px' }}>
        <a
          href={`${NEVM_EXPLORER_URL}/block/${nevm.block_hash}`}
          className="nav-button"
          target="_blank"
          rel="noopener"
        >
          View on Blockscout ↗
        </a>
      </p>
    </div>
  </div>
);
